// store.js - Central store for application state

// Application state
const state = {
    // Authentication state
    isAuthenticated: false,
    currentWalletAddress: null,
    isGuestMode: false,
    accountType: null,
    userEmail: null,
    userCredits: 0,
    
    // Conversations state
    conversations: [],
    currentConversationId: null,
    
    // Messages state
    pendingResponses: {},
    
    // UI state
    confirmCallback: null,
    
    // New state variable
    openedLearnMoreFromLogin: false,
    
    // Getters
    getIsAuthenticated() {
        return this.isAuthenticated;
    },
    
    getWalletAddress() {
        return this.currentWalletAddress;
    },
    
    getIsGuestMode() {
        return this.isGuestMode;
    },
    
    getAccountType() {
        return this.accountType;
    },
    
    getUserEmail() {
        return this.userEmail;
    },
    
    getUserCredits() {
        return this.userCredits;
    },
    
    getConversations() {
        return this.conversations;
    },
    
    getCurrentConversationId() {
        return this.currentConversationId;
    },
    
    getPendingResponses() {
        return this.pendingResponses;
    },
    
    getOpenedLearnMoreFromLogin() {
        return this.openedLearnMoreFromLogin;
    },
    
    // Setters
    setAuthenticated(value) {
        this.isAuthenticated = value;
    },
    
    setWalletAddress(address) {
        this.currentWalletAddress = address;
    },
    
    setGuestMode(value) {
        this.isGuestMode = value;
    },
    
    setAccountType(type) {
        this.accountType = type;
    },
    
    setUserEmail(email) {
        this.userEmail = email;
    },
    
    setUserCredits(credits) {
        this.userCredits = credits;
    },
    
    setConversations(conversations) {
        this.conversations = conversations;
    },
    
    setCurrentConversationId(id) {
        this.currentConversationId = id;
    },
    
    setPendingResponse(conversationId, isPending) {
        if (isPending) {
            this.pendingResponses[conversationId] = true;
        } else {
            delete this.pendingResponses[conversationId];
        }
    },
    
    setConfirmCallback(callback) {
        this.confirmCallback = callback;
    },
    
    setOpenedLearnMoreFromLogin(value) {
        this.openedLearnMoreFromLogin = value;
    }
};

export default state;